export default __webpack_public_path__ + "static/024-9c9997ff80559d613555bde3a0c19f72.jpg";